import { Checkbox, FormControlLabel } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import Http from '../../../../Http';

export default function FoliosUso(props) {
  const Params = useParams();
  const [Cliente, setCliente] = useState({});

  // useEffect(() => {
  //   console.log(Params);
  // }, []);

  useEffect(() => {
    const loadDef = async () => {
      let Res = await Http.get(`cliente-manifiesto/${Params.id}/uso-manifiestos`);
      if (!Res.error) {
        setCliente(Res.data);
      }
    }
    loadDef();
  }, [Params])

  const onClienteManifiestoChange = async (e) => {
    console.log(e.target.checked);
    try {
      let data = { id: Params.id, cliente_uso_folios: e.target.checked };
      let Res = await Http.post(`cliente/save`, data);
      if (!Res.error) {
        console.log('saved', Res.data.data);
        setCliente({ ...Cliente, cliente_uso_folios: Res.data.data.cliente_uso_folios })
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div style={{ padding: 20, textAlign: 'center' }}>
      <h4>Uso de folios</h4>
      <FormControlLabel
        control={<Checkbox checked={Cliente.cliente_uso_folios || false} onChange={onClienteManifiestoChange} name="antoine" />}
        label="Usar folios propios"
      />
    </div>
  )
}
